'use client';

import {RELATIVE_DATE_OPTIONS, resolveRelativeDate} from 'iq-interview_experiences/constants';
import {FlowLabel, FlowInput, FlowPillButton} from './flow_form';

type Props = {
  customDate: string;
  onCustomDateChange: (value: string) => void;
};

export function FlowDateField({customDate, onCustomDateChange}: Props) {
  return (
    <div className='flex flex-col gap-2'>
      <FlowLabel>When did you interview?</FlowLabel>
      <div className='flex flex-wrap gap-2 mb-1'>
        {RELATIVE_DATE_OPTIONS.map((opt) => {
          const resolved = resolveRelativeDate(opt.value);
          return (
            <FlowPillButton
              key={opt.value}
              selected={customDate === resolved}
              selectedClassName='bg-iq-black text-white border-iq-black'
              onClick={() => onCustomDateChange(resolved)}>
              {opt.label}
            </FlowPillButton>
          );
        })}
      </div>
      <FlowInput
        type='date'
        value={customDate}
        onChange={(e) => onCustomDateChange(e.target.value)}
        max={new Date().toISOString().split('T')[0]}
        min={(() => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 6); return d.toISOString().split('T')[0]; })()}
      />
    </div>
  );
}
